import {datatables} from '#/js/inline/datatables';

export default function () {
  datatables();
  const payableRevenue = $.fn.dataTable.absoluteOrder({
    value: '', position: 'bottom'
  });
  const listTable = $('#userListTable');
  listTable.DataTable({
    dom: 'Bfrtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print',
    ],
    language: {
      search: "_INPUT_",
      searchPlaceholder: window.Lang.get('general.search') + '...',
    },
    columnDefs: [
      {targets: listTable.find('th.revenue').index(), type: payableRevenue}
    ]
  });
}
